import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTPagination, { KTPaginationColor } from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import EmptyView from 'general/components/Others/EmptyView';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import _, { fill } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import ToastHelper from 'general/helpers/ToastHelper';
import AppConstants from 'general/constants/AppConstants';
import FileUploadView from 'general/components/quybka/Uploads/FileUploadView';
import * as ExcelJS from 'exceljs';
import JSZip from 'jszip';
import AppRoute from 'general/constants/AppRoute';
import FleetHelper from 'features/Fleet/fleetHelper';

DriverReconciliationListView.propTypes = {};

const defaultColumnIds = [
    'RECONCILIATION_ID',
    'MONTH',
    'DRIVER_ID',
    'DRIVER_CODE',
    'DRIVER_NAME',
    'TRANSACTION_NUM',
    'CHARGE_AMOUNT',
    'DRIVER_PAID_AMOUNT',
    'FLEET_PAID_AMOUNT',
    'DATE',
];

function DriverReconciliationListView(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const { agencyId } = router.query;
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.auth);
    const [reconciliationList, setReconciliationList] = useState([]);
    const [total, setTotal] = useState([]);
    const [totalAmount, setTotalAmount] = useState([]);
    const [filter, setFilter] = useState(FleetHelper.Filter.reconciliationList);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        handleGetDriverReconciliationList();
    }, [filter, user])

    const fullColumns = useMemo(() => {
        return [
            {
                id: 'RECONCILIATION_ID',
                name: UIHelper.buildTableColumn('Mã đối soát'),
                selector: (row) => (
                    <span
                        className="cursor-pointer hover-opacity-60"
                        onClick={() => {
                            if (Utils.isValid(row?.document)) {
                                Utils.openInNewTab(Utils.getFullUrl(row?.document));
                            }
                        }}
                    >
                        {row?.reconciliationCode ?? row?.reconciliationId}
                    </span>
                ),
                width: '140px',
                style: tableStyle.columns.link,
            },
            {
                id: 'MONTH',
                name: UIHelper.buildTableColumn('Kỳ đối soát'),
                selector: (row) => Utils.formatDateTimeToString(row?.month, 'MM/yyyy'),
                width: '140px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'DRIVER_ID',
                omit: !adminRole,
                name: UIHelper.buildTableColumn('Mã tài xế hệ thống'),
                selector: (row) => row.driver?.driverCode ?? row?.driver?.driverId,
                width: '150px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'DRIVER_CODE',
                omit: !adminRole,
                name: UIHelper.buildTableColumn('Mã tài xế doanh nghiệp'),
                selector: (row) => row.driver?.companyCode,
                width: '170px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'DRIVER_NAME',
                omit: !adminRole,
                name: UIHelper.buildTableColumn('Tên tài xế'),
                selector: (row) => (
                    <span
                        className="cursor-pointer hover-opacity-60"
                        onClick={() => {
                            Utils.openInNewTab(`${AppRoute.customerList}/${row?.driver?.userId}`)
                        }}
                    >
                        {row?.driver?.fullname}
                    </span>
                ),
                minWidth: '240px',
                style: tableStyle.columns.link,
            },
            {
                id: 'TRANSACTION_NUM',
                name: UIHelper.buildTableColumn('Tổng số phiên sạc'),
                selector: (row) => Utils.formatNumber(row?.totalTransactions ?? 0),
                width: '140px',
                style: tableStyle.columns.normal,
                right: true,
            },
            {
                id: 'CHARGE_AMOUNT',
                name: UIHelper.buildTableColumn('Tổng chi phí sạc', 'VNĐ'),
                selector: (row) => Utils.formatNumber(row?.totalChargingCost ?? 0),
                width: '140px',
                style: tableStyle.columns.normal,
                right: true,
            },
            {
                id: 'DRIVER_PAID_AMOUNT',
                name: UIHelper.buildTableColumn('Số tiền tài xế đã chi trả', 'VNĐ'),
                selector: (row) => Utils.formatNumber(row?.driverPaidAmount ?? 0),
                width: '170px',
                style: tableStyle.columns.normal,
                right: true,
            },
            {
                id: 'FLEET_PAID_AMOUNT',
                name: UIHelper.buildTableColumn('Số tiền doanh nghiệp đã chi trả', 'VNĐ'),
                selector: (row) => Utils.formatNumber(row?.fleetPaidAmount ?? 0),
                width: '220px',
                style: tableStyle.columns.normal,
                right: true,
            },
            {
                id: 'DATE',
                name: UIHelper.buildTableColumn('Ngày tạo'),
                selector: (row) => (
                    <span>{Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY')}</span>
                ),
                width: '120px',
                style: tableStyle.columns.normal,
            },
            {
                name: UIHelper.buildTableColumn('Thao tác'),
                width: '100px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                center: true,
                cell: (row) => {
                    return (
                        <MenuActionDropdown
                            menuAction={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-eye"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('Xem chi tiết'),
                                    click: () => {
                                        router.navigate(`${row?.reconciliationId}`);
                                    },
                                    show: true,
                                },
                            ]}
                        />
                    )
                },
            }
        ];
    }, [user, adminRole]);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = router.pathname;
        const key = `${userId}_${pathName}`;
        return key;
    }, [user, router]);
    const [fullColumnIds, setFullColumnIds] = useState(
        fullColumns?.map((row) => row?.id).filter(Boolean) || []
    );
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        saveChanges,
        resetDefaultTableColumn,
        onSelectAll,
        onUnSelectAll,
        fullColumnsSorted,
        fullColumnsIdSorted,
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    // MARK: ---- METHODS ----
    const handleGetDriverReconciliationList = () => {
        if (agencyId) {
            FleetHelper.API.requestGetDriverReconciliationList(Utils.filterParams({ ...filter, agencyId }))
                .then((data) => {
                    if (data) {
                        setReconciliationList(data?.reconciliations);
                        setTotal(data?.total);
                        setTotalAmount(data?.totalAmount);
                        setIsReady(true);
                    }
                })
        }
    };

    const handleViewFiles = (files) => {
        AppCustomDialogHelper.show(
            'Tệp đính kèm',
            <FileUploadView
                pathList={files}
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
            />,
            'md',
            false,
            true
        );
    };

    // xuat file excel
    const handleExportExcel = async (exportData, params) => {
        let exportDataList = exportData;
        if (_.isEmpty(exportDataList)) {
            ToastHelper.showError('Không có dữ liệu để tải xuống');
            return;
        }

        const zip = new JSZip();
        const sheetFileName = 'BBDS DNVT_Tổng quan';
        const ext = '.xlsx';
        const folderName = 'BBDS DNVT_Chi tiết';
        const zipFileName = `BBDS DNVT_${Utils.formatDateTimeToString(params?.month, 'MMYYYY')}.zip`;

        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet(sheetFileName, {
            headerFooter: { firstHeader: sheetFileName },
        });

        sheet.mergeCells('A1:H1');
        sheet.getCell('A1').value = `BÁO CÁO ĐỐI SOÁT KỸ THUẬT VIÊN`;
        sheet.getCell('A1').font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
        };
        sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        sheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '29618E' },
            color: { argb: 'FFFFFF' },
        };
        sheet.getCell('A1').border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };
        sheet.getRow(1).height = 25;

        const columns = [
            { key: 'stt', width: 7 },
            { key: 'reconciliationCode', width: 18 },
            { key: 'month', width: 18 },
            { key: 'agencyCode', width: 18 },
            { key: 'agencyName', width: 35 },
            { key: 'amount', width: 35 },
            { key: 'paymentStatus', width: 22 },
            { key: 'date', width: 22 },
        ];
        sheet.columns = columns;

        sheet.getRow(2).height = 30;
        sheet.getRow(2).font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
        };
        sheet.getRow(2).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
        };

        sheet.getCell('A2').value = 'STT';
        sheet.getCell('B2').value = 'Mã đối soát';
        sheet.getCell('C2').value = 'Kỳ đối soát';
        sheet.getCell('D2').value = 'Mã DNVT';
        sheet.getCell('E2').value = 'Tên DNVT';
        sheet.getCell('F2').value = 'Tổng tiền DNVT được nhận (VNĐ)';
        sheet.getCell('G2').value = 'Trạng thái thanh toán';
        sheet.getCell('H2').value = 'Ngày tạo';

        ['A2:H2'].forEach((range) => {
            sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
        });

        let i = 1;
        exportDataList?.forEach((row) => {
            const dataRow = sheet.addRow({
                stt: i++,
                reconciliationCode: row?.reconciliationCode ?? row?.reconciliationId,
                month: Utils.formatDateTimeToString(row?.month, 'MM/yyyy'),
                agencyCode: row.agency?.agencyCode ?? row?.agency?.agencyId,
                agencyName: row?.agency?.name,
                amount: Utils.formatNumber(row?.netAmount ?? 0),
                paymentStatus: FleetHelper.Utils.getReconciliationPaymentStatusName(row.metadata?.totalTicket, row.metadata?.receivedTicket),
                date: row?.createdAt ? Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm') : '',
            });

            dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                if (colNumber === 1) {
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                } else if (colNumber == 6) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                }
            });
        });

        sheet.eachRow((row, rowNumber) => {
            if (rowNumber >= 3) {
                row.font = {
                    name: 'Times New Roman',
                    family: 4,
                    size: 11,
                    bold: false,
                };
            }
        });

        const mainFileBuffer = await workbook.xlsx.writeBuffer();
        zip.file(`${sheetFileName}${ext}`, mainFileBuffer);

        const detailFolder = zip.folder(folderName);

        const fetchPromises = exportDataList?.map(async (row, index) => {
            if (row?.documentXLSX) {
                try {
                    const fileName = await Utils.getFileNameFromPath(row?.documentXLSX);
                    const file = await Utils.urlToFile(row?.documentXLSX, fileName);
                    const fileBuffer = await file.arrayBuffer();
                    const zipFileName = `${row?.reconciliationCode}_${Utils.formatDateTimeToString(params?.month, 'MMYYYY')}_BBDS DNVT.company${ext}`;
                    detailFolder.file(zipFileName, fileBuffer);
                } catch (error) {
                    console.error(`Lỗi khi xử lý file ${row.documentXLSX}:`, error.message);
                    ToastHelper.showError(`Không tải được file ${row?.reconciliationCode ?? `item_${index + 1}`}: ${error.message}`);
                }
            }
        });

        await Promise.all(fetchPromises);

        try {
            const content = await zip.generateAsync({ type: 'blob' });
            const url = window.URL.createObjectURL(content);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = zipFileName;
            anchor.click();
            window.URL.revokeObjectURL(url);
            ToastHelper.showSuccess('Tải xuống file ZIP thành công');
        } catch (error) {
            console.error('Lỗi khi tạo file ZIP:', error.message);
            ToastHelper.showError('Không thể tạo file ZIP');
        } finally {
            AppCustomDialogHelper.hide();
        }
    };

    const paymentStatusOptions = [
        { name: 'Tất cả', value: '' },
        { name: 'Đã thanh toán', value: 'COMPLETED' },
        { name: 'Chưa thanh toán', value: 'PENDING' }
    ]

    return (
        <div>
            {UIHelper.buildCard(
                <div className="pb-4">
                    {/* header */}
                    <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column">
                            <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                Đối soát tài xế doanh nghiệp • {`DN${agencyId?.toString().padStart(8, '0')}`}
                            </span>
                            <div>
                                <span
                                    className="font-weight-bolder"
                                    style={{ fontSize: '14px', color: AppColors.gray[800] }}
                                >
                                    Tổng:{' '}
                                </span>
                                <span
                                    className="font-weight-bolder"
                                    style={{ fontSize: '14px', color: AppColors.primary }}
                                >
                                    {Utils.formatNumber(total ?? reconciliationList?.length)} đối soát
                                </span>
                                <span
                                    className="font-weight-bolder"
                                    style={{ fontSize: '14px', color: AppColors.gray[500] }}
                                >
                                    {' '} • {' '}
                                </span>
                                <span
                                    className="font-weight-bolder"
                                    style={{ fontSize: '14px', color: AppColors.primary }}
                                >
                                    {Utils.formatNumber(totalAmount)} VNĐ
                                </span>
                            </div>
                        </div>
                        <div>
                            {adminRole && (
                                <div className="d-flex align-items-center justify-content-end gap-3 flex-wrap">
                                    {UIHelper.buildBlueButton(
                                        'Tải xuống',
                                        async () => {
                                            // try {
                                            //     const params = { ..._.omit(FleetHelper.Filter.reconciliationList, ['limit', 'page']), limit: 1000000 }
                                            //     const { reconciliations = [] } = await FleetHelper.API.requestGetReconciliationList(Utils.filterParams(params));
                                            //     return handleExportExcel(reconciliations, params);
                                            // } catch (error) {
                                            //     ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                                            //     return [];
                                            // }
                                        },
                                        <i className="far fa-download" style={{ color: '#FFFFFF', fontSize: 15 }} />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* table */}
                    <div className="">
                        {/* filter */}
                        <div className="row m-0 p-0 px-2">
                            {/* tim kiem */}
                            <div className="col mb-4 px-2 pt-1">
                                {UIHelper.buildFormLabel('Tìm kiếm')}
                                <KTFormSearch
                                    name="search"
                                    placeholder={adminRole ? "Theo mã đối soát, mã tài xế, tên tài xế..." : "Theo mã đối soát"}
                                    value={filter.q}
                                    onSubmit={(text) => {
                                        FleetHelper.Filter.reconciliationList = {
                                            ...FleetHelper.Filter.reconciliationList,
                                            q: text,
                                            page: 0,
                                        };
                                        setFilter(FleetHelper.Filter.reconciliationList);
                                    }}
                                />
                            </div>
                            {/* thang doi soat */}
                            <div className="col mb-4 px-2">
                                {UIHelper.buildFormLabel('Kỳ đối soát')}
                                <KTFormInput
                                    name="month"
                                    type={KTFormInputType.month}
                                    onChange={(value) => {
                                        FleetHelper.Filter.reconciliationList = {
                                            ...FleetHelper.Filter.reconciliationList,
                                            month: value,
                                            page: 0,
                                        };
                                        setFilter(FleetHelper.Filter.reconciliationList);
                                    }}
                                    value={filter.month}
                                    placeholder='MM/YYYY'
                                />
                            </div>
                            {/* trang thai thanh toan */}
                            {/* <div className="col mb-4 p-0 px-2">
                                {UIHelper.buildFormLabel('Trạng thái thanh toán')}
                                <KTBSDropdown
                                    name="paymentStatus"
                                    toggleElement={
                                        <button
                                            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                            type="button"
                                        >
                                            {paymentStatusOptions.find(item => item.value === filter.paymentStatus)?.name}
                                        </button>
                                    }
                                    selectedValue={filter.paymentStatus}
                                    dropdownMenuItems={paymentStatusOptions}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                    onChange={(value) => {
                                        FleetHelper.Filter.reconciliationList = {
                                            ...FleetHelper.Filter.reconciliationList,
                                            paymentStatus: value,
                                            page: 0,
                                        };
                                        setFilter(FleetHelper.Filter.reconciliationList);
                                    }}
                                    isDropdownForm={true}
                                />
                            </div> */}
                            <div className="col mb-4 p-2 d-flex align-items-end gap-3">
                                {/* cau hinh cot */}
                                <DropdownTableConfigColumn
                                    columnIds={columnIds}
                                    fullColumns={fullColumns}
                                    fullColumnIds={fullColumnsIdSorted}
                                    onChangeCheckboxValue={onChangeCheckboxValue}
                                    saveChanges={saveChanges}
                                    resetDefaultTableColumn={() => {
                                        setFullColumnIds(defaultColumnIds);
                                        resetDefaultTableColumn();
                                    }}
                                    onChangeFullColumnIds={(ids) => {
                                        setFullColumnIds(ids);
                                        const key = prefKey + '_FULL_COLUMN_IDS';
                                        localStorage.setItem(key, ids.join('|'));
                                    }}
                                    onSelectAll={onSelectAll}
                                    onUnSelectAll={onUnSelectAll}
                                />
                            </div>
                        </div>

                        <div className="px-4">
                            <KTTable
                                columns={columns}
                                items={reconciliationList}
                                selectableRows={false}
                                striped={false}
                                compactGrid={false}
                                onClickedRow={(row) => { }}
                                onSelectedRowsChanged={(rows) => { }}
                                onDoubleClickedRow={(rows) => { }}
                                noDataComponent={
                                    <EmptyView
                                        icon={imgEmptyNoData}
                                        title="Không có dữ liệu để hiển thị"
                                        text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                                    />
                                }
                            />
                        </div>
                    </div>

                    {/* pagination */}
                    <div className="px-4 mt-2">
                        <KTPagination
                            currentPage={filter.page + 1}
                            rowCount={total ?? reconciliationList?.length}
                            rowsPerPage={filter.limit}
                            currentItemInPageCount={reconciliationList.length}
                            onChangePage={(newPage) => {
                                const iNewPage = parseInt(newPage);
                                FleetHelper.Filter.reconciliationList = {
                                    ...FleetHelper.Filter.reconciliationList,
                                    page: iNewPage - 1,
                                };
                                setFilter(FleetHelper.Filter.reconciliationList);
                            }}
                            onChangeRowsPerPage={(newRowsPerPage) => {
                                const iNewRowsPerPage = parseInt(newRowsPerPage);
                                FleetHelper.Filter.reconciliationList = {
                                    ...FleetHelper.Filter.reconciliationList,
                                    limit: iNewRowsPerPage,
                                    page: 0,
                                };
                                setFilter(FleetHelper.Filter.reconciliationList);
                            }}
                            color={KTPaginationColor.success}
                            appendText="đối soát"
                        />
                    </div>
                </div>,
                false
            )}
        </div>
    );
}

export default DriverReconciliationListView;
